"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentMeet = exports.PagoSolidario = exports.PagoSemanal = exports.NegocioMarcha = exports.GroupMeeting = exports.AsistenciaGrupo = exports.Asistencia = exports.ActGroupCredit = void 0;
var _datastore = require("@aws-amplify/datastore");
var _schema = require("./schema");
// @ts-check

var NegocioMarcha = {
  "SI": "SI",
  "NO": "NO"
};
exports.NegocioMarcha = NegocioMarcha;
var AsistenciaGrupo = {
  "SI": "SI",
  "NO": "NO"
};
exports.AsistenciaGrupo = AsistenciaGrupo;
var Asistencia = {
  "ATIEMPO": "ATIEMPO",
  "LLEGOTARDE": "LLEGOTARDE",
  "NOASISTIO": "NOASISTIO"
};
exports.Asistencia = Asistencia;
var PagoSemanal = {
  "COMPLETO": "COMPLETO",
  "INCOMPLETO": "INCOMPLETO"
};
exports.PagoSemanal = PagoSemanal;
var PagoSolidario = {
  "SI": "SI",
  "NO": "NO",
  "PAGONOREQUERIDO": "PAGONOREQUERIDO"
};
exports.PagoSolidario = PagoSolidario;
var _initSchema = (0, _datastore.initSchema)(_schema.schema),
  GroupMeeting = _initSchema.GroupMeeting,
  ActGroupCredit = _initSchema.ActGroupCredit,
  PaymentMeet = _initSchema.PaymentMeet;
exports.PaymentMeet = PaymentMeet;
exports.ActGroupCredit = ActGroupCredit;
exports.GroupMeeting = GroupMeeting;